export function PercentageBadge({ value, type = 'positive' }: { value: string, type?: 'positive' | 'negative' | 'neutral' }) {
  const baseClasses = "px-3 py-1.5 rounded-full text-xs font-bold tracking-wide flex items-center justify-center shadow-sm";
  const typeClasses = {
    positive: "bg-emerald-100 text-emerald-800 border border-emerald-200/50",
    negative: "bg-rose-100 text-rose-800 border border-rose-200/50",
    neutral: "bg-stone-200 text-stone-700 border border-stone-300/50"
  };

  return (
    <div className={`${baseClasses} ${typeClasses[type]}`}>
      {value}
    </div>
  );
}
